import React from 'react';
import _ from 'lodash';
import { windowResize, changeNoticeMessage, changeProgress } from '../actions';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import axios from 'axios';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { CustomTextField, LeftContainer, Gutter, WindowsBigtitle, BlueButton, PrimaryButton, ButtonA, PrimaryButtonBtn, ButtonLink } from '../stylesheets/components';

import { TextField, Input } from 'final-form-material-ui';
import { Button } from '@material-ui/core';


const Fragment = React.Fragment;
const NewBox = styled.div`
  position: fixed;
  left: 50%;
  bottom: 15px;
  transform: translate(-50%, 0);
  width: 414px;
  padding: 20px;
  background: white;
  padding: 20px;
  box-shadow: 1px 1px 1px rgba(17, 17, 17, 0.15);
  z-index: 6;



  @media (max-width: 768px) {
    
    width: calc(100vw - 40px);
    height: calc(100vh - 40px);
    overflow-y:scroll;
    -webkit-overflow-scrolling: touch;
    box-shadow: none;
    left: 0;
    top: 0;
    transform: none;
  }
`;

const Title = styled.h2`
  font-family: "Noh Optique Display";
  font-weight: bold;
  font-size: 20px;
  line-height: 25px;
  border-bottom: 1px solid #DDDDDD;
  margin-bottom: 10px;
  padding-bottom: 5px;
  text-align: center;
`

const CloseBtn = styled(Link)`
  position: absolute;
  right: 20px;
  top: 20px;
`
const ContLabel = styled.label`
  font-weight: 600;
  color: #333333;
  margin: 5px 0;
  display: block;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;


const FormField = styled.div`
  padding: 10px 0;
  display: flex;
  justify-content: space-between;

  label {
    color: #828282;
    min-width: 120px;
  }

  input {
    border: none;
    width: 330px;
    font-size: 1.0em;
    background:transparent;
  }

  &:last-child {
    border-bottom: none;
  }
`;


const ButtonArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  a {
    margin-left: 5px;
  }
`;

const Flash = styled.div`
  
`;

class PasswordEdit extends React.Component {
  constructor(props) {
    super(props);
  }

  async handleSubmit(values) {
    const headers = {
      'X-CSRF-Token': this.props.csrfToken,
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }

    this.props.dispatch(changeProgress(true));
    const response = await fetch("/users/password", { method: "put", body: JSON.stringify(values), headers });
    if (response.ok) {
      let data = await response.json();
      

      this.props.dispatch(changeNoticeMessage("Password is successfully changed. Please sign in here!"));
      this.props.dispatch(changeProgress(false));
      this.props.history.push('/users/sign_in');

    } else {
      let data = await response.json();

      let errors = {};

      if (!errors.user) {
        errors.user = {};
      }
      this.props.dispatch(changeProgress(false));
      errors.user = data.errors;
      return errors;

    }


    // if (response.ok) {

    // } else {
    //   let rr = response.clone().json();
    //   console.log(rr)
    //   return rr;
    // }
  }

  handleValidate(values) {
    const errors = {};
    if (values.user) {

      if (!values.user.password) {
        if (!errors.user) {
          errors.user = {};
        }
        errors.user.password = 'Required';
      } else {

        if (values.user.password.length < 4) {
          if (!errors.user) {
            errors.user = {};
          }
          errors.user.password = 'Passsword should be longer than 3';
        }
      }

      if (!values.user.password_confirmation) {
        if (!errors.user) {
          errors.user = {};
        }
        errors.user.password_confirmation = 'Required';
      }

      if (values.user.password !== values.user.password_confirmation) {
        if (!errors.user) {
          errors.user = {};
        }
        errors.user.password_confirmation = 'Should match with the password';
      }



    }
    return errors;
  }



  render() {
    let { errors } = this.props;


    const tokenDom = document.querySelector("meta[name=csrf-token]");
    const csrfToken = tokenDom.content;
    return (
      <LeftContainer>
        <WindowsBigtitle>
          Reset Password
        </WindowsBigtitle>



        {
          _.isUndefined(errors) ?
            null :
            <DeviseError {...errors} />
        }
        {
          this.props.flash ?
            <Fragment>

              {
                _.isUndefined(this.props.flash.alert) ? null :
                  <div>
                    {this.props.flash.alert}
                    <Gutter h={6} />
                  </div>
              }

              {
                _.isUndefined(this.props.flash.notice) ? null :
                  <div>
                    {this.props.flash.notice}
                    <Gutter h={6} />
                  </div>
              }
            </Fragment> : null
        }


        <Form
          onSubmit={this.handleSubmit.bind(this)}
          validate={this.handleValidate.bind(this)}
          initialValues={{
            user: {
              reset_password_token: this.props.reset_password_token
            }
          }}
          render={({ handleSubmit, form, submitting, pristine, values }) => (
            <form onSubmit={handleSubmit}>
              <FormField>
                <Field
                  fullWidth
                  required
                  name="user[password]"
                  component={CustomTextField}
                  type="password"
                  label="Password"
                />
              </FormField>
              <FormField>
                <Field
                  fullWidth
                  required
                  name="user[password_confirmation]"
                  component={CustomTextField}
                  type="password"
                  label="Password Confirmation"
                />
              </FormField>

              <Gutter h={20} />

              <ButtonArea>
                <div>
                  <BlueButton
                    selected={true} 
                    disabled={submitting || pristine}>
                    Submit
                  </BlueButton>
                </div>
              </ButtonArea>
            </form>
          )}
        />

      </LeftContainer>
    );
  }
}

let mapStateToProps = state => {
  return {
    csrfToken: state.csrfToken
  }
}

export default connect(mapStateToProps)(PasswordEdit);